// src/FCMToken.js
import { messaging, getToken } from './firebase';
import { BASEURL } from './utils/helper';
import { Cookies } from 'react-cookie';
import axios from 'axios';

export const requestFirebaseNotificationPermission = async () => {
    try {
        console.log(Notification.permission === 'granted')
        // Notification.requestPermission().then(permission => {
        //     console.log('Notification permission:', permission);
        // });

        const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
        const token = await getToken(messaging, {
            vapidKey: process.env.REACT_APP_FIREBASE_KEY,
            serviceWorkerRegistration: registration
        });
        if (!token) throw new Error('No token received');
        // Send token to your backend
        const cookies = new Cookies()
        await axios.post(`${BASEURL}/partner/fcm-token`, { fcm_token: token },
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${cookies.get('auth')}`,
                }
            }).then((res) => {
                console.log('FCM Token saved successfully:', res.data);
            }).catch((error) => {
                console.error('Error saving FCM token:', error);
            })
        return token;
    } catch (error) {
        console.error('Error getting FCM token:', error);
        return null;
    }
};
